<template>
    <div class="module_page page_content stream_reports" aria-label="Stream Reports">

      <div class="row page-heading">
        <div class="col-7 input module_heading">
          <span class="module_icon icon-stream"></span>
		  <label class="head_txt module_type_name"><span v-if="advisorTitle">{{advisorTitle}}'s Report</span><span v-if="!advisorTitle">{{stream.title}}</span></label>
        </div>
        <div class="col-5 right-container">
		   <stream-header :uuid="uuid" :userId="userId" active="category"></stream-header>
        </div>
      </div>

	     <div class="page-content">
		    <stream-menu :uuid="uuid" active="report"></stream-menu>

  			<div class="col-11 dasboard-left-section">
          <report-list :isAdvisor="isAdvisor" :adviseeName="adviseeName" :adviseeUuid="userId" :adviseeRole="adviseeRole"></report-list>
  			</div>
	   </div>

  </div>
</template>

<script>
import '../../../assets/module/css/employer/employerHome.min.css'
import { mapState, mapActions } from 'vuex'
import StreamMenu from './StreamMenu'
import StreamHeader from './StreamHeader'
import ReportList from '../../institution/components/ReportList'

export default {
  name: 'streamReport',
  props: ['uuid', 'userId'],
  components: {
    StreamMenu,
    StreamHeader,
    ReportList
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole')
    }
  },

  mounted () {
    this.loadStream()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadStreamDetail',
      'loadLogDashboardActivity',
      'loadStreamDetailByUserId'
    ]),

    loadStream () {
      if (this.userId) {
        this.loadStreamDetailByUserId(this.userId)
      } else {
        this.loadLogDashboardActivity({action: 'viewStreamReportView', page: 'streamReportView', link: '', entityUuid: this.uuid})
        this.loadStreamDetail(this.uuid)
      }
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream
    }),
    isAdvisor () {
      if (this.userrole === 'Advisor' || this.userrole === 'Recruiter') {
        return true
      } else {
        return false
      }
    },
    adviseeName () {
      return this.stream.ownerName
    },
    adviseeUuid () {
      return this.stream.ownerId
    },
    adviseeRole () {
      return 'Student'
    },
    advisorTitle () {
      if (this.userrole === 'Advisor' || this.userrole === 'Recruiter') {
        return '' + this.stream.ownerName + ''
      } else {
        return ''
      }
    }
  },

  watch: {
  }
}
</script>
<style>
.jumbotron {
  background: #fffff;
}
.text-center {
  text-align: center;
}
.bg-gray{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamReport.vue